import { render, staticRenderFns } from "./SxMaterialAddOrUpdate.vue?vue&type=template&id=36460c0c&scoped=true&"
import script from "./SxMaterialAddOrUpdate.vue?vue&type=script&lang=js&"
export * from "./SxMaterialAddOrUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36460c0c",
  null
  
)

export default component.exports